import { ref } from 'vue';
import type {
    LayoutStateKeyType,
    LayoutStateConfigType,
    LayoutStateReturnType,
} from '@/types/composables/LayoutStateTypes';

const getStorageKey = (key: LayoutStateKeyType): string => `layout_${key}`;

const loadFromStorage = (key: LayoutStateKeyType, defaultValue: boolean): boolean => {
    try {
        const storageKey = getStorageKey(key);
        const saved = localStorage.getItem(storageKey);

        return saved !== null ? JSON.parse(saved) : defaultValue;
    } catch (error) {
        console.warn(`Failed to load layout state for ${key}:`, error);

        return defaultValue;
    }
};

const saveToStorage = (key: LayoutStateKeyType, value: boolean): void => {
    try {
        const storageKey = getStorageKey(key);
        localStorage.setItem(storageKey, JSON.stringify(value));
    } catch (error) {
        console.warn(`Failed to save layout state for ${key}:`, error);
    }
};

export const useLayoutState = (config: LayoutStateConfigType): LayoutStateReturnType => {
    const { key, defaultValue } = config;

    const state = ref(loadFromStorage(key, defaultValue));

    const save = () => {
        saveToStorage(key, state.value);
    };

    return {
        state,
        save,
    };
};
